// extracted by mini-css-extract-plugin
module.exports = {"singleAreaRoot":"areaDetails_singleAreaRoot__2VCey","title":"areaDetails_title__JJqrG"};